// Auto-generated map registry for frontend
export const MAP_REGISTRY = {
  "0": {
    "name": "simple",
    "displayName": "Simple Grid",
    "description": "Basic 10x5 grid layout with straightforward connections"
  },
  "1": {
    "name": "choke",
    "displayName": "Choke Points",
    "description": "Strategic bottlenecks and bridge territories create tactical challenges"
  },
  "2": {
    "name": "classic",
    "displayName": "Classic World",
    "description": "Traditional world map with continents and natural boundaries"
  },
  "3": {
    "name": "small",
    "displayName": "Small Tactics",
    "description": "Compact 10-territory map with mountains and lake terrain for quick tactical games"
  }
};

export const MAP_CONFIGS = {
  0: () => import('./simple-map.js'),
  1: () => import('./choke-map.js'),
  2: () => import('./classic-map.js'),
  3: () => import('./small-map.js'),
};

export function getMapDisplayName(mapType) {
  return MAP_REGISTRY[mapType]?.displayName || `Map ${mapType}`;
}

export function getMapDescription(mapType) {
  return MAP_REGISTRY[mapType]?.description || '';
}

export async function loadMapData(mapType) {
  const loader = MAP_CONFIGS[mapType];
  if (!loader) {
    throw new Error(`Map type ${mapType} not found`);
  }
  return await loader();
}
